var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m80.718 152h30v30c0 8.284-6.716 15-15 15s-15-6.716-15-15v-30h-44.081c-10.615 0-19.38 8.292-19.969 18.891l-16.605 298.89c-1.274 22.928 16.975 42.219 39.938 42.219h162.384c-9.061-13.037-13.537-28.937-12.41-44.924l11.888-168.593c.893-12.664 6.5-24.405 15.787-33.061s21.394-13.422 34.089-13.422h68.599l-4.506-81.109c-.589-10.599-9.354-18.891-19.969-18.891h-39.145v-64c0-48.523-39.477-88-88-88s-88 39.477-88 88zm30-64c0-31.981 26.019-58 58-58s58 26.019 58 58v64h30v30c0 8.284-6.716 15-15 15s-15-6.716-15-15v-30h-116z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m511.899 469.186-11.888-168.593c-.739-10.474-9.451-18.593-19.951-18.593h-228.321c-10.5 0-19.212 8.119-19.95 18.593l-11.888 168.593c-1.632 23.142 16.702 42.814 39.901 42.814h212.196c23.199 0 41.533-19.672 39.901-42.814zm-90.124-109.044c0 31.903-25.955 57.858-57.857 57.858-31.903 0-57.858-25.955-57.858-57.858v-18.142c0-8.284 6.716-15 15-15s15 6.716 15 15v18.142c0 15.361 12.497 27.858 27.858 27.858 15.36 0 27.857-12.497 27.857-27.858v-18.142c0-8.284 6.716-15 15-15s15 6.716 15 15z",
    "data-original": "#000000",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.1f8f6ee42e3832c1f6443ae493865982.svg";
export { ForwardRef as ReactComponent };